export const isService = (amenityID) => {
    const serviceArray = [22, 1, 43, 25, 44, 24, 40, 39, 45, 26,46, 47, 48, 49,54, 55,57];
    //    const serviceArray = [22, 1, 43, 25, 44, 24, 40, 39, 45, 26,46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57];
  if (serviceArray.includes(amenityID)) {
    return true;
  } else {
    return false;
  }
};
